import Vue from 'vue'
import App from './App'
import router from './router'
import './style/iconfont.css'
import store from './store'
import ba from 'vue-ba'

// 百度统计
Vue.use(ba, '9387d57ee7d0d9b0d850eef1a7c6bf37')
Vue.config.productionTip = false
Vue.prototype.imgRoot = 'http://cdn.zulonentertainment.com'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js